import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private api: ApiService) { }

  getAllEvents(data:any): Observable<any> {
    return this.api.post(environment.getAllEvents,data);
  }

  createEvent(data:any): Observable<any> {
    return this.api.post(environment.createEvent,data);
  }

  updateEvent(data:any): Observable<any> {
    return this.api.post(environment.updateEvent,data);
  }

  deleteEvent(data:any): Observable<any> {
    return this.api.post(environment.deleteEvent,data);
  }
}


